import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService } from 'app/services';
import { MerchantConfirmOnboardingComponent } from 'app/components/merchant/merchant-confirm-onboarding/merchant-confirm-onboarding.component';

@Component({
    selector: 'merchant-company-confirm',
    templateUrl: './merchant-company-confirm.component.html',
    styleUrls: ['./merchant-company-confirm.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class MerchantCompanyConfirmComponent implements OnInit {
    public showMerchantCompanyConfirmSideBar: boolean = false;
    @Input()
    set _showMerchantCompanyConfirmSideBar(value: boolean) {
        this.showMerchantCompanyConfirmSideBar = value;
    }

    @Input() public merchantConfirmOnboardingComponent!: MerchantConfirmOnboardingComponent;

    @Output() changedShowMerchantCompanyConfirmSideBarEmit = new EventEmitter<boolean>();
    changedShowMerchantCompanyConfirmSideBar(increased: any) {
        this.changedShowMerchantCompanyConfirmSideBarEmit.emit(increased);
    }

    public merchantCompany: any = {};
    @Input()
    set _merchantCompany(obj: any) {
        this.merchantCompany = obj;
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService) { }

    public loading: boolean = false;

    ngOnInit(): void {
    }

    public confirm() {
        this.loading = true;

        const dto = {
            MerchantId: this.merchantCompany.MerchantId,
            BusinessName: this.merchantCompany.BusinessName,
            BusinessAddress: this.merchantCompany.BusinessAddress,
            BusinessCity: this.merchantCompany.BusinessCity,
            BusinessPostalCode: this.merchantCompany.BusinessPostalCode,
            TradingName: this.merchantCompany.TradingName,
            BusinessPhone: this.merchantCompany.BusinessPhone,
            BusinessEmail: this.merchantCompany.BusinessEmail
        };

        if (!dto.BusinessName || !dto.BusinessAddress || !dto.TradingName) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Fill all required fields.' });
            this.loading = false;
            return;
        }

        this.merchantService.merchantCompanyUpdate(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.merchantConfirmOnboardingComponent.getMerchantUserAndMerchantForConfirmed();
            this.changedShowMerchantCompanyConfirmSideBar(false);
        });
    }

    cancel() {
        this.changedShowMerchantCompanyConfirmSideBar(this.showMerchantCompanyConfirmSideBar);
    }
}
